module.exports = __webpack_public_path__ + "img/logo-mini.42ac5b8a.svg";